module.exports = {"id":"dp4_4l1q3","text":"Environmental Impacts of Digital Technologies","instructions":"Which action can help reduce energy use when using digital devices?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"4.4","questionType":"PickOne","random":true,"options":[{"id":"dp4_4l1q3-a1","text":"Turning devices off when idle","score":1.8},{"id":"dp4_4l1q3-a2","text":"Leaving apps running continuously","score":0},{"id":"dp4_4l1q3-a3","text":"Increasing screen brightness","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat4.4/l1q3.json
// module id = 1269
// module chunks = 41